import { render, staticRenderFns } from "./formulaire.vue?vue&type=template&id=1168b9a8&"
import script from "./formulaire.vue?vue&type=script&lang=js&"
export * from "./formulaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports